import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { LocalStorageService } from '../../../services/localStorageService';
import { readApiEndpointV1, meetQbrickDomain } from '../../../utils/config';

interface AddSpeakerModalProps {
    open: boolean;
    onClose: () => void;
    mediaId: string;
    mediaDetails: any;
}

const AddSpeakerModal = ({ open, onClose, mediaId, mediaDetails }: AddSpeakerModalProps) => {
    const { t } = useTranslation();
    const jitsiRoomName = useSelector((state: any) => state.liveManager.jitsiRoomName);
    const defaultAccountId = useSelector((state: any) => state.session.defaultAccountId);

    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [profileImageUrl, setProfileImageUrl] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setEmail('');
        setUsername('');
        setProfileImageUrl('');
        onClose();
    };

    const handleSubmit = async () => {
        setLoading(true);
        const rawEventDate = mediaDetails?.custom?.['event-start'] ?? mediaDetails?.custom?.livemanager?.start ?? '';
        const eventDate = rawEventDate ? new Date(rawEventDate).toISOString() : '';
        const payload = {
            email,
            username,
            eventLink: `https://${meetQbrickDomain}/${jitsiRoomName}`,
            mediaId,
            eventDate,
            type: 'Speaker',
            profileImageUrl,
        };

        try {
            await fetch(
                `${readApiEndpointV1}accounts/${defaultAccountId}/meetings/${jitsiRoomName}/register`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${LocalStorageService.getAccessToken()}`,
                    },
                    body: JSON.stringify(payload),
                }
            );
        } finally {
            setLoading(false);
            handleClose();
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" className="meeting-modal">
            <DialogTitle>
                <span className="modal-title">Add Speaker</span>
                <IconButton onClick={handleClose} className="close-btn">
                    <Close/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <TextField
                    label={t('COMMON_EMAIL')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                />
                <TextField
                    label={t('COMMON_USERNAME')}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                />
                <TextField
                    label={t('COMMON_PROFILE_IMAGE_URL')}
                    value={profileImageUrl}
                    onChange={(e) => setProfileImageUrl(e.target.value)}
                    fullWidth
                    margin="normal"
                    variant="outlined"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}></Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    disabled={loading || !email || !username}
                >
                    {loading ? t('COMMON_ADDING') : t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_PARTICIPANTS_ADD_SPEAKER')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddSpeakerModal;
